/**
 * @description 查询事件数据
 * 不了解数据结构的可先参考 https://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=239234920
 * @author wangfupeng
 */

import { each } from '../util'

// 准备网页数据
// const scenes = window.SCENES || {}
// const eventTable = scenes.eventTable || {}
// const _global = window.GLOBAL_DATA || {}
// const nextUrls = _global.nextUrls || {}

let scenes
let eventTable
let _global
let nextUrls

// 存储数据列表（根据 layerId 组织）
let EVENT_LIST

/**
 * 试图从 nextUrls 中获取链接
 * @param {String} id nextUrl id
 * @returns {String} 成功返回链接，失败返回传入的 id
 */
function getTargetUrl(id) {
    if (!id || nextUrls[id] == null) {
        return id
    }
    const nextUrl = nextUrls[id]
    if (nextUrl.shortLink) {
        return nextUrl.shortLink
    }
    if (nextUrl.link) {
        return nextUrl.link
    }
    return id
}

/**
 * 获取事件列表，根据 layerId 组件
 */
function getEventList() {
    const result = {}

    // 遍历 eventTable
    each(eventTable, (key, eventInfo) => {
        // 节点 id
        const id = eventInfo.refId

        // 为每个节点，都新建一个数组，存储事件列表
        if (result[id] == null) {
            result[id] = []
        }
        const eventArr = result[id]

        // 记录当前事件
        eventArr.push(eventInfo)
    })

    return result
}

/**
 * 获取该组件的事件列表
 * @param {string} id layerId
 */
function query(id) {
    if (scenes == null) scenes = window.SCENES || {}
    if (eventTable == null) eventTable = scenes.eventTable || {}
    if (_global == null) _global = window.GLOBAL_DATA || {}
    if (nextUrls == null) nextUrls = _global.nextUrls || {}
    if (EVENT_LIST == null) {
        EVENT_LIST = getEventList()
    }
    return EVENT_LIST[id] || []
}

export {
    query,
    getTargetUrl
}
